import httpRequest from '@/api/request'
import { IPageBaseParamsType } from '@/api/public.interface.ts'
import {
  IResModuleTxListItemType,
  IResModuleAccountDetailType,
  IResModuleTxListParamsType,
} from '@/api/moduleAccount/interface.ts'
/**
 * @description 获取账户详情
 * @param {string}  address
 * */
export const getModuleAccountDetail = (address: string): Promise<IResModuleAccountDetailType> => {
  return httpRequest.get(`/api/account/detail`, {
    params: {
      address,
    },
  })
}

/**
 * @description 获取交易列表信息
 * */
export const getModuleAccountTxList = (
  params: IResModuleTxListParamsType,
): Promise<{
  ModuleTransfer: IResModuleTxListItemType[]
  group_count?: number
  next_key?: string
  total_count?: number
  offset_key?: string
}> => {
  return httpRequest.get(`/api/account/module_transfer`, {
    params,
  })
}
